import { render } from "./CxChip.vue?vue&type=template&id=7fe4fe67"
import script from "./CxChip.vue?vue&type=script&lang=js"
export * from "./CxChip.vue?vue&type=script&lang=js"

import "./CxChip.vue?vue&type=style&index=0&id=7fe4fe67&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__